<!-- display a checkbox in user management page for "OnLegalHold" column -->
<mat-checkbox [(ngModel)]="params.value" aria-label="OnLegalHold" (change)="this.refresh(this.params)"
    *ngIf="this.checkVisible"
    class ='checked-color-after checked-color-before'>
</mat-checkbox>
<div *ngIf=!checkVisible>
    {{params.value}}
</div>